import { Box, FlexLayout, H4, Icon } from '@deity/falcon-ui';
import { DefinitionFactory } from '@deity-io/di-data-structure-editor';
import { Select } from '@deity-io/portal-ui';
import { Tooltip } from 'components/Tooltip';
import type { FC } from 'react';
import { useState } from 'react';

interface IScalarTypePickerProps {
  isEditable: boolean;
  property: string;
  name?: string;
  options: any[];
  value: string | number | undefined;
  description: string;
  disableClearable?: boolean;
  error?: boolean;
  onSelect: (val) => void;
}
const ScalarTypePicker: FC<IScalarTypePickerProps> = ({
  isEditable,
  error,
  property,
  options,
  name,
  value,
  description,
  disableClearable = true,
  onSelect
}) => {
  const [availableTypes] = useState(() => DefinitionFactory.availableFieldTypes());

  return (
    <FlexLayout p="xs" bg="panelLight" borderRadius="small" width="full">
      <FlexLayout alignItems="center" width="full">
        <FlexLayout width="full" alignItems="center" justifyContent="space-between" mb="xs">
          <H4 fontWeight="bold" mr="xs" style={{ textTransform: 'capitalize' }}>
            {name || property}
          </H4>
          {description && (
            <Tooltip content={description} direction="left">
              <Icon src="helpOutline" color="secondary" stroke="transparent" />
            </Tooltip>
          )}
        </FlexLayout>
        <Box width="full">
          <Select
            label={property}
            onChange={(option: any) => onSelect(option?.value)}
            options={availableTypes?.map(option => ({
              value: option,
              label: option
            }))}
            error={error}
            value={{ value: (value as any) || '', label: (value as any) || '' }}
            disabled={!isEditable}
            disableClearable={disableClearable}
            autoComplete
          />
        </Box>
      </FlexLayout>
    </FlexLayout>
  );
};

export default ScalarTypePicker;
